/**
 *  Copyright (c) 2022-present TVM Engineering Authors.
 *
 */

import { amber, green } from "@mui/material/colors";
import { backgroundColor, sideBarBoxShadow, textColorSideBarMenu } from "./defaultStyles";
import SideBarConfig from "../configs/SideBarConfig";

const drawerWidth = SideBarConfig.config.drawerWidth;

const drawerSideBarMenuStyles = (theme) => ({
  MuiPaper: {
    root: {
      color: backgroundColor,
      background: "#ffffff", // '#42335D',
    },
  },
  MuiDrawer: {
    paper: {
      boxShadow: sideBarBoxShadow,
      // background: '#ffffff', // '#42335D',
    },
    paperAnchorLeft: {
      boxShadow: sideBarBoxShadow,
      // background: '#ffffff', // '#42335D',
    },
    paperAnchorDockedLeft: {
      boxShadow: sideBarBoxShadow,
      // background: '#ffffff', // '#42335D',
    },
  },
  MuiListItemIcon: {
    root: {
      color: "#607d8b",
    },
  },
  flex: {
    display: "inline-flex",
  },
  root: {
    display: "flex",
  },
  toolbar: {
    minHeight: 64,
    alignItems: "flex-start",
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2),
  },
  appBar: {
    color: "#fff",
    // borderBottom: '4px solid #5bd0ef',
    background: backgroundColor, // '#2C1C4B',
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    zIndex: "1201",
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: -12,
    marginRight: theme.spacing(2),
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    overflowX: "hidden",
    width: drawerWidth,
    boxShadow: sideBarBoxShadow,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(1),
    // paddingTop: theme.spacing(10),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: +drawerWidth,
    minHeight: "700px",
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  list: {
    color: textColorSideBarMenu,
    width: "auto",
  },
  fullList: {
    width: "auto",
  },
  alignLogoContainer: {
    // display: 'inline-flex',
    paddingLeft: "24%",
    // textAlign: 'center',
  },
  alignHeaderMenus: {
    textAlign: "end",
    marginLeft: "-7%",
    paddingTop: "20px",
  },
  headerLogo: {
    width: "240px",
    cursor: "pointer",
    display: "inline-block",
    paddingTop: "8px",
    fontSize: "1.1rem",
    color: "#fff",
    // fontWeight: '300'
    // width: "75%",
    // cursor: 'pointer',
    // display: 'inline-block',
    // paddingTop: '10px',
    // padding: '8px',
    // fontSize: '1.1rem',
    // color: '#fff',
    // fontWeight: '400'
  },
  headerSubText: {
    display: "inline-block",
    paddingTop: "10px",
    padding: "8px",
    fontSize: "1.1rem",
    // color: '#fff',
    // fontWeight: '300'
  },
  alignMenuNav: {
    color: "#393939",
    paddingTop: "14px",
    display: "inline-flex",
    float: "right",
  },
  alignNavLinkUnAuth: {
    color: "#505257",
    fontSize: "18px",
    paddingTop: "15px",
    paddingRight: "20px",
    fontFamily: '"Roboto", sans-serif',
    fontWeight: "300",
    // float: 'right',
  },
  alignWorkerMeta: {
    paddingTop: "12px",
    marginRight: "25px",
    fontWeight: "300",
    display: "inline-block",
    fontSize: "initial",
    float: "right",
  },
  nested: {
    paddingLeft: 15,
  },
  countryList: {
    maxHeight: 320,
  },
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.main,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: "flex",
    alignItems: "center",
  },
  alerMessage: {
    fontWeight: "400",
    fontSize: "1.5rem",
  },
  snackBar: {
    "& .MuiAlert-icon": {
      alignItems: "center",
    },
  },
});

export default drawerSideBarMenuStyles;
